module.exports = __webpack_public_path__ + "prod/1.42.2/img/personnel-one.74ad8e76.png";